import { render, staticRenderFns } from "./SkeletonBaseSummaryList.vue?vue&type=template&id=01f6a277"
import script from "./SkeletonBaseSummaryList.vue?vue&type=script&lang=js"
export * from "./SkeletonBaseSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports